import Register from "./Register";
import Render from "./Render";
import Provider from "./Provider";

export default {
  Register,
  Render,
  Provider
};
